module.exports = __webpack_public_path__ + "static/media/icon-online-money-transfer.f67ec752.svg";